import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import {
  Button,
  Collapse,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import { KeyboardTimePicker } from '@material-ui/pickers';
import * as Actions from 'app/store/actions';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { MdHighlightOff } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useRestricoesStyles } from './styles';

const nenhumDiaSelecionado = [false, false, false, false, false, false, false];

const dias = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

const messageIntercessao =
  'Pelo menos um dia da semana e horário informado já foi adicionado para acesso ao sistema. Não é permitido cadastro duplicado.';

const Restricoes = ({ id, name, values, onChange }) => {
  const styles = useRestricoesStyles();

  const dispatch = useDispatch();

  const [diasSelecionados, setDiasSelecionados] = useState(nenhumDiaSelecionado);
  const [horaInicio, setHoraInicio] = useState(null);
  const [horaFim, setHoraFim] = useState(null);

  const [erroHoraInicio, setErroHoraInicio] = useState(false);
  const [erroHoraFim, setErroHoraFim] = useState(false);
  const [touchedAdd, setTouchedAdd] = useState(false);

  const handleClickDia = (index, selecionado) => {
    const novaSelecao = [...diasSelecionados];
    novaSelecao[index] = selecionado;
    setDiasSelecionados(novaSelecao);
  };

  const validateHoraInicio = (touched) => {
    let isValid = true;
    if (!horaInicio) {
      if (touched) {
        setErroHoraInicio(mensagemCampoObrigatorio('uma hora inicial'));
        isValid = false;
      }
    } else if (!horaInicio.isValid()) {
      if (touched) {
        isValid = false;
        setErroHoraInicio('Hora inválida');
      }
    } else {
      setErroHoraInicio('');
    }

    return isValid;
  };

  const validateHoraFim = (touched) => {
    let isValid = true;
    if (!horaFim) {
      if (touched) {
        setErroHoraFim(mensagemCampoObrigatorio('uma hora final'));
        isValid = false;
      }
    } else if (!horaFim.isValid()) {
      if (touched) {
        isValid = false;
        setErroHoraFim('Hora inválida');
      }
    } else {
      setErroHoraFim('');
    }
    return isValid;
  };

  const validateHoraFimMaiorQueHoraInicio = () => {
    let isValid = true;
    if (
      (horaFim && !horaInicio) ||
      (horaFim && horaInicio && horaFim.isValid() && horaInicio.isValid() && horaFim.isBefore(horaInicio))
    ) {
      setErroHoraFim('Hora final deve ser maior que hora inicial');
      isValid = false;
    }
    return isValid;
  };

  useEffect(() => {
    if (horaInicio || horaFim) {
      validateHorarios();
    }
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [horaInicio, horaFim, touchedAdd]);

  const valuesHorario = values?.horario;
  useEffect(() => {
    setTouchedAdd(false);
    setErroHoraInicio('');
    setErroHoraFim('');
  }, [valuesHorario]);

  const validateHorarios = (touched) => {
    let isValid = true;
    if (values?.horario === 'CUSTOMIZADO') {
      const horaFimMaiorQueHoraInicio = validateHoraFimMaiorQueHoraInicio();

      if (horaFimMaiorQueHoraInicio) {
        const inicioValido = validateHoraInicio(touched);
        const fimValido = validateHoraFim(touched);

        isValid = inicioValido && fimValido;
      } else {
        isValid = false;
      }
    }

    return isValid;
  };

  const DayButton = ({ index, onClick, diasSelecionados }) => {
    const selecionado = diasSelecionados[index];

    const labels = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

    return (
      <Button
        onClick={() => {
          setTimeout(() => onClick(index, !selecionado), 100);
        }}
        variant={selecionado ? 'contained' : 'outlined'}
        className={styles.button}
        color={selecionado ? 'primary' : 'default'}
      >
        {labels[index]}
      </Button>
    );
  };

  const temIntercessaoHorarios = (h1, h2) => {
    if (!h1 || !h2) {
      return false;
    }

    if (h1.inicio.isSame(h2.inicio) || h1.fim.isSame(h2.fim)) {
      return true;
    }

    const min = h1.inicio.isBefore(h2.inicio) ? h1 : h2;
    const max = h1 === min ? h2 : h1;

    return max.inicio < min.fim;
  };

  const handleAdd = () => {
    const fullTime = {
      inicio: moment('00:00:00', 'HH:mm:ss'),
      fim: moment('23:59:59', 'HH:mm:ss'),
    };

    setTouchedAdd(true);

    if (diasSelecionados.every((dia) => !dia)) {
      const messageSemDiasInformados = 'É necessário informar pelo menos um dia da semana para adicionar.';
      dispatch(Actions.showMessage({ message: messageSemDiasInformados, variant: 'error' }));
      return;
    }

    if (!validateHorarios(true)) {
      return;
    }

    const horariosAcesso = diasSelecionados.map((dia) => {
      if (dia) {
        if (values?.horario !== 'CUSTOMIZADO') {
          return fullTime;
        }
        return {
          inicio: horaInicio,
          fim: horaFim,
        };
      }
      return undefined;
    });

    let temIntercessao = false;

    horariosAcesso.forEach((horario, index) => {
      if (values?.horariosAcesso?.[index]?.length) {
        if (
          values?.horariosAcesso?.[index].some((horarioJaRegistrado) =>
            temIntercessaoHorarios(horario, horarioJaRegistrado)
          )
        ) {
          temIntercessao = true;
        }
      }
    });

    if (!temIntercessao) {
      const novosHorarios = values?.horariosAcesso?.map((horario, index) => {
        if (horariosAcesso[index]) {
          if (horario) {
            horario.push(horariosAcesso[index]);
            return horario;
          }
          return [horariosAcesso[index]];
        }
        return horario;
      });

      onChange({
        target: {
          id: `${id}.horariosAcesso`,
          value: novosHorarios,
        },
      });

      setTouchedAdd(false);
      setDiasSelecionados(nenhumDiaSelecionado);
      setHoraInicio(null);
      setHoraFim(null);
    } else {
      dispatch(Actions.showMessage({ message: messageIntercessao, variant: 'error' }));
    }
  };

  const handleRemover = (index1, index2) => {
    const novosHorarios = values?.horariosAcesso?.map((horario, i1) => {
      if (i1 === index1) {
        return horario?.filter((_, i2) => index2 !== i2);
      }
      return horario;
    });

    onChange({
      target: {
        id: `${id}.horariosAcesso`,
        value: novosHorarios,
      },
    });
  };

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={styles.container1}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography>
              Selecione os dias da semana e horários que o acesso é permitido e clique em "Adicionar".
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {diasSelecionados.map((key, index) => (
              <DayButton key={index} index={index} onClick={handleClickDia} diasSelecionados={diasSelecionados} />
            ))}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FormControl id={`${id}.horario`} name={`${id}.horario`} component="fieldset" onChange={onChange}>
              <RadioGroup
                defaultValue="QUALQUER_HORA"
                value={values?.horario}
                aria-label="gender"
                name="restricoes.horario"
              >
                <FormControlLabel value="QUALQUER_HORA" control={<Radio color="primary" />} label="Acessar 24 horas" />
                <FormControlLabel value="CUSTOMIZADO" control={<Radio color="primary" />} label="Definir horários" />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Collapse in={values?.horario === 'CUSTOMIZADO'} className={styles.fullWidth}>
            <div className={styles.collapse}>
              <div className={styles.containerHorario}>
                <div className={styles.timePicker}>
                  <KeyboardTimePicker
                    margin="normal"
                    id={`${id}.inicio`}
                    name={`${name}.inicio`}
                    label="Hora inicial*"
                    autoOk
                    inputVariant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    ampm={false}
                    value={horaInicio}
                    onChange={setHoraInicio}
                    error={!!erroHoraInicio}
                    helperText={erroHoraInicio}
                    KeyboardButtonProps={{
                      'aria-label': 'change time',
                    }}
                  />
                </div>
                <div className={styles.timePicker}>
                  <KeyboardTimePicker
                    margin="normal"
                    id="time-picker"
                    label="Hora final*"
                    autoOk
                    inputVariant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={horaFim}
                    ampm={false}
                    onChange={setHoraFim}
                    error={!!erroHoraFim}
                    helperText={erroHoraFim}
                    KeyboardButtonProps={{
                      'aria-label': 'change time',
                    }}
                  />
                </div>
              </div>
            </div>
          </Collapse>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Button fullWidth variant="contained" className={styles.buttonSend} type="button" onClick={handleAdd}>
              Adicionar
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={styles.container2}>
        <Typography>Horários adicionados</Typography>
        {values?.horariosAcesso?.map((horarios, index) => {
          if (horarios?.length) {
            return (
              <>
                <p className="mt-8">
                  <b>{dias[index]}</b>
                </p>
                {horarios.map((horario, index2) => (
                  <p>
                    {horario.inicio.format('HH:mm')} - {horario.fim.format('HH:mm')}
                    <IconButton onClick={() => handleRemover(index, index2)}>
                      <MdHighlightOff size={18} />
                    </IconButton>
                  </p>
                ))}
              </>
            );
          }
          return null;
        })}
      </Grid>
    </Grid>
  );
};

export default Restricoes;
